<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  stockStatus: {
    type: String,
    required: true,
    validator: value =>
      ['available', 'low_stock', 'unavailable'].includes(value),
  },
});

const { t } = useI18n();

const label = computed(() => {
  if (props.stockStatus === 'available')
    return t('PURCHASE_PROJECTS.STOCK.AVAILABLE');
  if (props.stockStatus === 'low_stock')
    return t('PURCHASE_PROJECTS.STOCK.LOW_STOCK');
  return t('PURCHASE_PROJECTS.STOCK.UNAVAILABLE');
});
</script>

<template>
  <span
    class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
    :class="{
      'bg-n-teal-3 text-n-teal-11': stockStatus === 'available',
      'bg-n-amber-3 text-n-amber-11': stockStatus === 'low_stock',
      'bg-n-ruby-3 text-n-ruby-11': stockStatus === 'unavailable',
    }"
  >
    <span
      class="size-3 shrink-0"
      :class="{
        'i-lucide-circle-check': stockStatus === 'available',
        'i-lucide-triangle-alert': stockStatus === 'low_stock',
        'i-lucide-circle-x': stockStatus === 'unavailable',
      }"
    />
    {{ label }}
  </span>
</template>
